import '../../styles/pages/smart-sales.scss';
import '../../styles/external/op-calc-widget.css';
import './smart_sales_slider';
import '../external/op-calc-widget';
import { checkSellAdFields } from './sell_ad';
import { commonUtils } from './common_utils';

export const smartSale = {
    testimonials: () => {
        const testimonials = [
            Translations.smart_sale.testimonial_1,
            Translations.smart_sale.testimonial_2,
            Translations.smart_sale.testimonial_3,
            Translations.smart_sale.testimonial_4,
            Translations.smart_sale.testimonial_5,
        ];

        const changeTestimonial = () => {
            const randomIndex = commonUtils.generateRandomNumber(testimonials.length);
            $('#Testimonials').text(testimonials[randomIndex]);
        };

        // Change testimonial text every 5 seconds
        setInterval(changeTestimonial, 5000);

        // Initial call to display a testimonial immediately
        changeTestimonial();
    },
    showSmartSaleForm: () => {
        $('#smartSaleFormSection').removeClass('none');
        $('#smartSaleRegisterNumber').val('');
    },
    scrollToSmartSaleForm: () => {
        $('html,body').animate(
            {
                scrollTop: $('#smartSaleFormSection').offset().top - 15,
            },
            'slow'
        );
    },
    focusRegistrationField: () => {
        $('#vehicleRegisterNumber').focus();
    },
    checkAutoOpen: () => {
        if (window.location.hash === '#createVerifiedAd') {
            smartSale.showSmartSaleForm();
            smartSale.scrollToSmartSaleForm();
            smartSale.focusRegistrationField();
            // Remove hash from URL after processing to keep URL clean
            history.replaceState(null, null, ' ');
        }
    },
    initAccordion: () => {
        const accordionItems = document.querySelectorAll('.smart-sale__faq-section__item');

        accordionItems.forEach((item) => {
            const question = item.querySelector('.smart-sale__faq-section__question');

            question.addEventListener('click', () => {
                const isActive = item.classList.contains('smart-sale__faq-section__item--active');

                // Close all accordion items
                accordionItems.forEach((accordionItem) => {
                    accordionItem.classList.remove('smart-sale__faq-section__item--active');
                    const questionButton = accordionItem.querySelector('.smart-sale__faq-section__question');
                    questionButton.setAttribute('aria-expanded', 'false');
                });

                // Open clicked item if it wasn't active
                if (!isActive) {
                    item.classList.add('smart-sale__faq-section__item--active');
                    question.setAttribute('aria-expanded', 'true');
                }
            });
        });
    },
};

$(function () {
    let $body = $('body');

    // GA4 pageview event for Smart Sales landing page
    try {
        commonUtils.dataLayer.genericData({
            event: 'page_view',
            page: 'smart_sales_landing',
            page_title: document.title,
            page_location: window.location.href,
        });
    } catch (error) {
        console.error('Failed to track pageview:', error);
    }

    try {
        smartSale.testimonials();
    } catch (error) {
        console.error('Failed to initialize testimonials:', error);
    }

    try {
        smartSale.initAccordion();
    } catch (error) {
        console.error('Failed to initialize accordion:', error);
    }

    try {
        smartSale.checkAutoOpen();
    } catch (error) {
        console.error('Failed to check auto open:', error);
    }

    // Click on create smart sale ad button
    $body.on('click', '.smartSaleAdFormOpen', function () {
        try {
            smartSale.showSmartSaleForm();
            smartSale.scrollToSmartSaleForm();
            smartSale.focusRegistrationField();
        } catch (error) {
            console.error('Failed to handle smart sale form:', error);
        }
    });

    // verified ad continue button click event
    $body.on('click', '#proceedToVerifiedAd', function () {
        let vehicleRegisterNumber = $('#vehicleRegisterNumber').val();

        if (vehicleRegisterNumber && !commonUtils.isValidRegistrationNumber(vehicleRegisterNumber)) {
            commonUtils.dataLayer.genericData({
                event: 'create_verified_ad_continue',
                page: 'smart_sales_landing',
                location: 'top',
            });
        }

        let vertical = 'bike';
        if (commonUtils.isNettiauto()) {
            vertical = 'car';
        } else if (commonUtils.isNettikaravaani()) {
            vertical = 'caravan';
        }

        checkSellAdFields.processVerifiedAd(vertical);
    });

    // Datalayer push event for smart sales create verified sale
    $body.on('click', '.dataLayerPush', function () {
        commonUtils.dataLayer.genericData({
            event: $(this).data('datalayer-event'),
            page: $(this).data('datalayer-page'),
            location: $(this).data('datalayer-location'),
        });
    });

    window.__opCalcAccount = window.__opCalcAccount
        ? window.__opCalcAccount
        : { mode: 'kertaluotto', key: 'fiksutkaupat' };
    window.__opCalcOpts = window.__opCalcOpts && Object.keys(window.__opCalcOpts).length ? window.__opCalcOpts : [];
    window.__opCalcOpts.content = {
        linkCta: 'https://hae.rahoitus.op.fi/kertaluotto/fiksutkaupat',
        linkMore: '',
        heading: 'Rahoituksen määrä',
        colorPrimary: '#0070e0',
        colorSecondary: '#ffffff',
        textOpenBtn: 'Maksa erissä',
        isSolo: false,
        enableInputChanges: true,
        showCta: true,
        showInput: true,
        type: 'content',
        initAmount: 5000,
        showInfo: {
            realInterest: true,
            interestMargin: true,
            paybackTime: true,
            costEstimate: true,
        },
    };
});
